import React from 'react';
import './ModernCard.css';

const ModernCard = ({ 
  children, 
  icon: Icon, 
  title, 
  description, 
  buttonText, 
  onClick, 
  className = '',
  variant = 'default' 
}) => {
  return (
    <div className={`modern-card ${variant} ${className}`}>
      {Icon && (
        <div className="card-icon">
          <Icon size={32} />
        </div>
      )}
      
      <div className="card-content">
        {title && <h3 className="card-title">{title}</h3>}
        {description && <p className="card-description">{description}</p>}
        {children}
      </div>
      
      {buttonText && onClick && (
        <button className="card-button" onClick={onClick}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default ModernCard;
